import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SwalService } from 'projects/shared/src/services/swal.service';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { SignalEventType } from 'projects/shared/src/models/SignalModel';
import { SignalRService } from 'projects/shared/src/services/signal-rservice.service';
import { MatDialog } from '@angular/material/dialog';
import { VerificationTaskService } from '../../../services/verification-task.service';
import { TaskComments } from 'projects/admin/src/app/features/verification-tasks/models/TaskComments';

@Component({
  selector: 'app-verification-task-comments',
  standalone: false,
  templateUrl: './verification-task-comments.component.html'
})
export class VerificationTaskCommentsComponent implements OnInit, OnDestroy {

  @Input() recordId!: number;
  comments: TaskComments[] = [];
  selectedComment: TaskComments | null
  dataLoading = false;
  commentsLoading = false
  loading = false


  ListSubscriptions: Subscription[] = [];
  subscriptions: Subscription[] = [];
  constructor(
    private service: VerificationTaskService,
    private swalService: SwalService,
    public translate: TranslateService,
    private signal: SignalRService,
    public dialog: MatDialog
  ) { }
  ngOnInit() {
    this.subscriptions.push(
      this.signal.getDataStream<string>(SignalEventType.commentUpdate)
        .subscribe(message => { this.commentUpdate(message.data); })
    )
    this.getAllTaskComments();
  }

  commentUpdate(data: any) {
    if (this.recordId == data.id) {
      this.dialog.closeAll();
      this.getAllTaskComments();
    }
  }

  getAllTaskComments() {
    this.ListSubscriptions.push(
      this.service.getAllTaskComments(this.recordId).subscribe(
        data => {
          if (data) {
            this.comments = data as any;
            this.commentsLoading = false;
          }
        },
        error => {
          this.handleErrors(error.detail)

        })
    )
  }

  submitComment(formValue: any, isReplay = true) {
    let commentFormModel: any = {};
    commentFormModel.verificationTaskId = this.recordId;
    commentFormModel.comment = formValue['comment'];
    if (this.selectedComment) {
      commentFormModel.id = this.selectedComment.id;
    }


    if (commentFormModel.id) {
      this.service.updateTaskComment(commentFormModel).subscribe(
        (res: any) => {
          this.loading = false;
          Swal.fire({
            title: this.translate.instant('evaluationTasks.commentUpdatedSuccessfully'),
            imageUrl: './assets/images/icons/success.svg',
            confirmButtonText: this.translate.instant('swalMsg.Ok'),
          });
          this.selectedComment = null
          this.getAllTaskComments();
        },
        (error: any) => {
          this.loading = false;
        }
      );
    } else {
      this.service.addTaskComment(commentFormModel).subscribe(
        (res: any) => {
          this.loading = false;
          Swal.fire({
            title: this.translate.instant('evaluationTasks.commentAddedSuccessfully'),
            imageUrl: './assets/images/icons/success.svg',
            confirmButtonText: this.translate.instant('swalMsg.Ok'),
          });
          this.selectedComment = null
          this.getAllTaskComments();
        },
        (error: any) => {
          this.loading = false;
        }
      );
    }
  }

  deleteComment(comment: TaskComments) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousuretodelete'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yesdeleteit'),
      cancelButtonText: this.translate.instant('swalMsg.Nokeepit'),
    }).then((result) => {
      if (result.value) {
        this.commentsLoading = true;
        this.service.deleteTaskComment(comment.id).subscribe(
          (data: any) => {
            if (data) {
              Swal.fire({
                title: this.translate.instant('swalMsg.Success'),
                text: this.translate.instant('swalMsg.deletededsuccessfuly'),
                imageUrl: './assets/images/icons/success.svg',
                confirmButtonText: this.translate.instant('swalMsg.Ok'),
              });
              this.getAllTaskComments();
            }
          },
          (error: any) => { }
        );
      }
    });
  }

  handleErrors(errors: any) {
    errors = JSON.parse(errors);
    errors.ErrorDTO.forEach((error: any) => {
      this.swalService.swalFailed(error.Error);
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.ListSubscriptions.forEach(sub => sub.unsubscribe());
  }
}
